/* Skyebloom theme scripts */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- focus trap helper ---------- */
  function trap(container) {
    var sel = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';
    return function (e) {
      if (e.key !== 'Tab') return;
      var f = Array.prototype.slice.call(container.querySelectorAll(sel)).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
  }

  /* ---------- mobile nav drawer ---------- */
  (function () {
    var drawer = document.querySelector('[data-sb-drawer]');
    var openBtn = document.querySelector('[data-sb-drawer-open]');
    if (!drawer || !openBtn) return;
    var panel = drawer.querySelector('.sb-drawer__panel');
    var trapHandler = trap(panel);
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.body.classList.add('sb-lock');
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      openBtn.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', onKey);
      document.addEventListener('keydown', trapHandler);
      var f = panel.querySelector('button, a');
      if (f) f.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('sb-lock');
      openBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('keydown', trapHandler);
      setTimeout(function () { drawer.hidden = true; }, 320);
      if (lastFocus) lastFocus.focus();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    openBtn.addEventListener('click', open);
    drawer.querySelectorAll('[data-sb-drawer-close]').forEach(function (el) { el.addEventListener('click', close); });
  })();

  /* ---------- collection filter drawer (mobile) ---------- */
  (function () {
    var filters = document.querySelector('[data-sb-filters]');
    var openBtn = document.querySelector('[data-sb-filter-open]');
    if (!filters || !openBtn) return;

    var scrim = document.createElement('div');
    scrim.className = 'sb-filter-scrim';
    document.body.appendChild(scrim);

    function isMobile() { return window.matchMedia('(max-width:980px)').matches; }
    function open() {
      if (!isMobile()) return;
      filters.classList.add('is-open');
      scrim.classList.add('is-open');
      document.body.classList.add('sb-lock');
    }
    function close() {
      filters.classList.remove('is-open');
      scrim.classList.remove('is-open');
      document.body.classList.remove('sb-lock');
    }
    openBtn.addEventListener('click', open);
    scrim.addEventListener('click', close);
    filters.querySelectorAll('[data-sb-filter-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('resize', function () { if (!isMobile()) close(); });
  })();

  /* ---------- bestseller / generic tabs ---------- */
  document.querySelectorAll('.sb-tabs').forEach(function (group) {
    var root = group.parentElement;
    var tabs = group.querySelectorAll('.sb-tab');
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        var pane = root.querySelector('#' + t.getAttribute('aria-controls'));
        if (pane) pane.hidden = !on;
      });
    }
    tabs.forEach(function (tab, x) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(x + 1) % tabs.length];
        if (e.key === 'ArrowLeft')  n = tabs[(x - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); select(n); n.focus(); }
      });
    });
  });

  /* ---------- hero banner ---------- */
  document.querySelectorAll('[data-sb-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('.sb-slide');
    var copies = hero.querySelectorAll('.sb-hero__copy');
    var dots = hero.querySelectorAll('.sb-hero__dots button');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var speed = (parseInt(hero.dataset.speed, 10) || 6) * 1000;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, x) { s.classList.toggle('is-on', x === i); });
      copies.forEach(function (c, x) { c.classList.toggle('is-on', x === i); });
      dots.forEach(function (d, x) { d.setAttribute('aria-current', x === i); });
    }
    function play() { stop(); if (!reduced && hero.dataset.autoplay === 'true') timer = setInterval(function () { go(i + 1); }, speed); }
    function stop() { clearInterval(timer); }
    dots.forEach(function (d, x) { d.addEventListener('click', function () { go(x); play(); }); });
    var next = hero.querySelector('[data-sb-next]'), prev = hero.querySelector('[data-sb-prev]');
    if (next) next.addEventListener('click', function () { go(i + 1); play(); });
    if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);
    hero.addEventListener('focusin', stop);
    var startX = null;
    hero.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      startX = null; play();
    }, { passive: true });
    play();
  });

  /* ---------- product gallery ---------- */
  var thumbs = document.querySelector('[data-sb-thumbs]');
  var main = document.getElementById('sbGalMain');
  if (thumbs && main) {
    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      thumbs.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b === btn); });
      main.src = btn.dataset.src;
      main.removeAttribute('srcset');
    });
  }

  /* ---------- variant picker ---------- */
  var form = document.getElementById('sbProductForm');
  var select = form && form.querySelector('[data-sb-variants]');
  if (form && select) {
    var chosen = [];
    form.querySelectorAll('.sb-optbtn[aria-pressed="true"]').forEach(function (b) { chosen[+b.dataset.optionIndex] = b.dataset.value; });
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('.sb-optbtn');
      if (!btn) return;
      var idx = +btn.dataset.optionIndex;
      form.querySelectorAll('.sb-optbtn[data-option-index="' + idx + '"]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn); });
      chosen[idx] = btn.dataset.value;
      var match = null;
      select.querySelectorAll('option').forEach(function (o) {
        var opts = (o.dataset.options || '').split('||');
        if (chosen.every(function (v, x) { return v === undefined || v === opts[x]; })) match = match || o;
      });
      if (!match) return;
      select.value = match.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      var url = new URL(window.location); url.searchParams.set('variant', match.value); window.history.replaceState({}, '', url);
      var price = (match.textContent.split('—')[1] || '').trim();
      var live = document.querySelector('.sb-now'), sticky = document.querySelector('[data-sb-sticky-price]');
      if (price && live) live.textContent = price;
      if (price && sticky) sticky.textContent = price;
      var submit = form.querySelector('button[type="submit"]');
      if (submit) submit.disabled = match.disabled;
    });
  }

  /* ---------- sticky add to bag ---------- */
  var sticky = document.querySelector('[data-sb-sticky]');
  var acts = document.querySelector('.sb-pdpacts');
  if (sticky && acts && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(acts);
    var add = sticky.querySelector('[data-sb-sticky-add]');
    /* sticky add-to-bag is handled by the AJAX cart module below */
  }

  /* ---------- offer countdown ---------- */
  document.querySelectorAll('[data-sb-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-sb-countdown').replace(' ', 'T')).getTime();
    if (isNaN(end)) return;
    var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'),
        m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    function pad(n){ return String(n).padStart(2,'0'); }
    function tick() {
      var ms = end - Date.now();
      if (ms <= 0) { if(d)d.textContent='00'; if(h)h.textContent='00'; if(m)m.textContent='00'; if(s)s.textContent='00'; return; }
      if(d) d.textContent = Math.floor(ms/86400000);
      if(h) h.textContent = pad(Math.floor(ms%86400000/3600000));
      if(m) m.textContent = pad(Math.floor(ms%3600000/60000));
      if(s) s.textContent = pad(Math.floor(ms%60000/1000));
      setTimeout(tick, 1000);
    }
    tick();
  });


  /* ---------- quantity stepper ---------- */
  document.querySelectorAll('[data-sb-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('.sb-qty__input');
    if (!input) return;
    function clamp(n) {
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 999;
      return Math.max(min, Math.min(max, n));
    }
    wrap.querySelector('[data-dec]').addEventListener('click', function () {
      input.value = clamp((parseInt(input.value, 10) || 1) - 1);
    });
    wrap.querySelector('[data-inc]').addEventListener('click', function () {
      input.value = clamp((parseInt(input.value, 10) || 1) + 1);
    });
    input.addEventListener('change', function () {
      input.value = clamp(parseInt(input.value, 10) || 1);
    });
  });


  /* ---------- AJAX add to cart + confirmation toast ---------- */
  (function () {
    function money(cents) {
      try { return (window.Shopify && Shopify.money_format)
        ? (cents/100).toLocaleString(undefined,{style:'currency',currency:'GBP'})
        : '£' + (cents/100).toFixed(2); }
      catch (e) { return '£' + (cents/100).toFixed(2); }
    }
    var toastEl;
    function ensureToast() {
      if (toastEl) return toastEl;
      toastEl = document.createElement('div');
      toastEl.className = 'sb-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
      return toastEl;
    }
    var hideTimer;
    function showToast(html, isError) {
      var t = ensureToast();
      t.innerHTML = html;
      t.classList.toggle('sb-toast--error', !!isError);
      t.classList.add('is-on');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () { t.classList.remove('is-on'); }, isError ? 4000 : 6000);
      var close = t.querySelector('[data-toast-close]');
      if (close) close.addEventListener('click', function () { t.classList.remove('is-on'); });
    }
    function refreshCount() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('[data-sb-cart-count]').forEach(function (el) {
            el.textContent = c.item_count;
            el.classList.toggle('is-empty', c.item_count === 0);
          });
        }).catch(function () {});
    }

    function addToCart(form, goCheckout) {
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (item) {
        refreshCount();
        if (btn) { btn.innerHTML = 'Added ✓'; setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1600); }
        if (goCheckout) { window.location.href = '/checkout'; return; }
        var img = item.image ? '<img src="' + item.image + '&width=120" alt="">' : '';
        showToast(
          '<div class="sb-toast__row">' + img +
          '<div class="sb-toast__txt"><b>Added to bag</b><span>' + (item.product_title || item.title) +
          (item.variant_title && item.variant_title.indexOf('Default') === -1 ? ' · ' + item.variant_title : '') + '</span></div>' +
          '<button class="sb-toast__x" data-toast-close aria-label="Close">✕</button></div>' +
          '<div class="sb-toast__acts"><a class="sb-btn sb-btn--ghost" href="/cart">View bag</a><a class="sb-btn" href="/checkout">Checkout</a></div>'
        );
      })
      .catch(function (err) {
        if (btn) { btn.innerHTML = original; btn.disabled = false; }
        var msg = (err && err.description) ? err.description : 'Sorry — could not add that to your bag.';
        showToast('<div class="sb-toast__row"><div class="sb-toast__txt"><b>Not added</b><span>' + msg + '</span></div>' +
                  '<button class="sb-toast__x" data-toast-close aria-label="Close">✕</button></div>', true);
      });
    }

    // cart offer: quick-add (plain buttons, not forms — see main-cart.liquid comment)
    document.addEventListener('click', function (e) {
      var qa = e.target.closest('[data-sb-quickadd]');
      if (!qa) return;
      var variantId = qa.getAttribute('data-sb-quickadd');
      if (!variantId) return;
      var original = qa.textContent;
      qa.disabled = true; qa.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
      .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
      .then(function () {
        // reload so the cart totals, line items, and offer box all re-evaluate correctly
        window.location.reload();
      })
      .catch(function (err) {
        qa.disabled = false; qa.textContent = original;
        var msg = (err && err.description) ? err.description : 'Sorry — could not add that.';
        showToast('<div class="sb-toast__row"><div class="sb-toast__txt"><b>Not added</b><span>' + msg + '</span></div>' +
                  '<button class="sb-toast__x" data-toast-close aria-label="Close">✕</button></div>', true);
      });
    });

    // card size chips select the variant
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('.sb-card__size');
      if (chip) {
        var form = chip.closest('form');
        if (!form) return;
        form.querySelectorAll('.sb-card__size').forEach(function (b) { b.setAttribute('aria-pressed', b === chip); });
        var idField = form.querySelector('[data-card-id]');
        if (idField) idField.value = chip.dataset.vid;
        var price = form.closest('.sb-card__body') && form.closest('.sb-card__body').querySelector('[data-card-price]');
        if (price && chip.dataset.price) price.textContent = chip.dataset.price;
      }
    });

    // intercept add-to-cart submits (cards + PDP)
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.sb-add-form');
      if (!form) return;
      try {
        e.preventDefault();
        addToCart(form, false);
      } catch (err) {
        // last-resort fallback: let the browser submit the form normally
        if (form.submit) form.submit();
      }
    });

    // "Buy now" / "Buy it now" — add, then go straight to checkout
    document.addEventListener('click', function (e) {
      var bn = e.target.closest('[data-sb-buynow]');
      if (!bn) return;
      e.preventDefault();
      var form = bn.closest('.sb-add-form') || document.getElementById('sbProductForm');
      if (form) addToCart(form, true);
    });

    // sticky bar "Add to bag" submits the PDP form via AJAX
    var stickyAdd = document.querySelector('[data-sb-sticky-add]');
    var pdpForm = document.getElementById('sbProductForm');
    if (stickyAdd && pdpForm) {
      stickyAdd.addEventListener('click', function () {
        if (pdpForm.requestSubmit) pdpForm.requestSubmit(); else addToCart(pdpForm, false);
      });
    }
  })();


  /* ---------- live cart: qty steppers + auto-update, no reload ---------- */
  (function () {
    var cartEl = document.querySelector('[data-sb-cart]');
    if (!cartEl) return;
    function money(c){ return '\u00a3' + (c/100).toFixed(2); }
    function busy(row, b){ row.style.opacity = b ? '.45' : ''; row.style.pointerEvents = b ? 'none' : ''; }
    function change(row, qty){
      var key = row.getAttribute('data-line-key');
      busy(row, true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-sb-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count === 0);
        });
        document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) { el.textContent = money(cart.total_price); });
        if (qty === 0) { row.remove(); if (cart.item_count === 0) window.location.reload(); return; }
        var li = null;
        for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].key === key) { li = cart.items[i]; break; } }
        if (li) {
          var pr = row.querySelector('[data-line-price]'); if (pr) pr.textContent = money(li.final_line_price);
          var inp = row.querySelector('[data-qty-input]'); if (inp) inp.value = li.quantity;
        }
        busy(row, false);
      })
      .catch(function () { busy(row, false); });
    }
    cartEl.addEventListener('click', function (e) {
      var row = e.target.closest('[data-line-key]'); if (!row) return;
      var inp = row.querySelector('[data-qty-input]'); var cur = parseInt(inp.value, 10) || 0;
      if (e.target.closest('[data-inc]')) change(row, cur + 1);
      else if (e.target.closest('[data-dec]')) change(row, Math.max(0, cur - 1));
      else if (e.target.closest('[data-cart-remove]')) { e.preventDefault(); change(row, 0); }
    });
    cartEl.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty-input]')) return;
      var row = e.target.closest('[data-line-key]');
      change(row, Math.max(0, parseInt(e.target.value, 10) || 0));
    });
  })();


  /* ---------- combo deal: add both products, apply discount, go to bag ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sb-combo]');
    if (!btn) return;
    e.preventDefault();
    var ids = btn.getAttribute('data-sb-combo').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    if (!ids.length) return;
    var discountCode = (btn.getAttribute('data-sb-combo-discount') || '').trim();
    var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
    var orig = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';

    // reuse (or create) a small error box right after the button
    var errEl = btn.nextElementSibling && btn.nextElementSibling.classList.contains('sb-combo__err')
      ? btn.nextElementSibling : null;
    function showComboError(msg) {
      if (!errEl) {
        errEl = document.createElement('p');
        errEl.className = 'sb-combo__err';
        btn.insertAdjacentElement('afterend', errEl);
      }
      errEl.textContent = msg;
    }
    if (errEl) errEl.textContent = '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
    .then(function () {
      if (discountCode) {
        // Shopify's own discount-redirect endpoint: applies the code to the
        // session, then lands on /cart with it already active.
        window.location.href = '/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart';
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(function (err) {
      btn.disabled = false; btn.textContent = orig;
      showComboError((err && err.description) ? err.description : 'Sorry — could not add the combo to your bag.');
    });
  });

})();